window.tinyMCE.PluginManager.add('custommargin', function (editor) {
  function updateRuler() {
    const rng = editor.selection.getRng();
    const node = rng.startContainer;
    const paragraph = editor.dom.getParent(node, 'p');
    const table = editor.dom.getParent(node, 'table');

    let leftMargin = '0%';
    let rightMargin = '0%';

    if (paragraph && !table) {
      leftMargin = editor.dom.getStyle(paragraph, 'margin-left', true) || '0%';
      rightMargin = editor.dom.getStyle(paragraph, 'margin-right', true) || '0%';
    } else if (table) {
      leftMargin = editor.dom.getStyle(table, 'margin-left', true) || '0%';
      rightMargin = editor.dom.getStyle(table, 'margin-right', true) || '0%';
    }

    const statusbarText = `Left Margin: ${leftMargin}, Right Margin: ${rightMargin}`;
    const statusbar = editor.theme.panel && editor.theme.panel.find('statusbar')[0];
    if (statusbar) {
      const marginStatus = statusbar.find('.margin-status-bar')[0];
      if (marginStatus) {
        marginStatus.text(statusbarText);
      } else {
        statusbar.insert(
          {
            type: 'label',
            name: 'margin-status',
            text: statusbarText,
            classes: 'margin-status-bar'
          },
          0
        );
      }
    }
  }

  editor.on('NodeChange', updateRuler);
  editor.on('SetContent', updateRuler);
  editor.on('GetContent', updateRuler);

  editor.addCommand('mceSetCustomMargin', function (ui, value) {
    const rng = editor.selection.getRng();
    const node = rng.startContainer;
    const paragraph = editor.dom.getParent(node, 'p');
    const table = editor.dom.getParent(node, 'table');

    if (paragraph && !table) {
      editor.dom.setStyle(paragraph, 'margin-left', value.left + '%');
      editor.dom.setStyle(paragraph, 'margin-right', value.right + '%');
    } else if (table) {
      const leftMargin = value.left + '%';
      const rightMargin = value.right + '%';

      editor.dom.setStyle(table, 'margin-left', leftMargin);
      editor.dom.setStyle(table, 'margin-right', rightMargin);
      editor.dom.setStyle(table, 'width', `calc(100% - ${leftMargin} - ${rightMargin})`);
    }

    updateRuler();
  });
  const horizontalRulerIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="24" height="30">' +
    // Rectangle
    '<rect x="4" y="10" width="30" height="10" stroke="black" stroke-width="1" fill="black" />' +
    // Small scale marks
    '<line x1="4" y1="24" x2="4" y2="28" stroke="black" stroke-width="1" />' +
    '<line x1="8" y1="24" x2="8" y2="27" stroke="black" stroke-width="1" />' +
    '<line x1="12" y1="24" x2="12" y2="28" stroke="black" stroke-width="1" />' +
    '<line x1="16" y1="24" x2="16" y2="27" stroke="black" stroke-width="1" />' +
    '<line x1="20" y1="24" x2="20" y2="28" stroke="black" stroke-width="1" />' +
    '<line x1="24" y1="24" x2="24" y2="27" stroke="black" stroke-width="1" />' +
    '<line x1="28" y1="24" x2="28" y2="28" stroke="black" stroke-width="1" />' +
    '</svg>';

  editor.ui.registry.addIcon('horizontalRuler', horizontalRulerIcon);
  editor.ui.registry.addButton('custommargin', {
    icon: 'horizontalRuler', // Use the customColumns icon
    tooltip: 'horizontal ruler',
    onAction: function () {
      openMarginDialog(editor);
    }
  });

  function openMarginDialog(editor) {
    editor.windowManager.open({
      title: 'Set Custom Margins',
      body: {
        type: 'panel',
        items: [
          {
            type: 'input',
            name: 'left',
            label: 'Left Margin (%)'
          },
          {
            type: 'input',
            name: 'right',
            label: 'Right Margin (%)'
          }
        ]
      },
      buttons: [
        {
          text: 'Apply',
          type: 'submit',
          primary: true
        },
        {
          text: 'Cancel',
          type: 'cancel'
        }
      ],
      onSubmit: function (api) {
        const data = api.getData();
        editor.execCommand('mceSetCustomMargin', false, data);
        api.close();
      }
    });
  }

  return {
    getMetadata: function () {
      return {
        name: 'Custom Margin Plugin'
      };
    }
  };
});

window.tinyMCE.init({
  selector: 'textarea',
  height: 500,
  menubar: true,
  plugins: 'custommargin',
  toolbar: 'undo redo | custommargin',
  setup: function (editor) {
    editor.on('init', function () {
      const statusbar = editor.theme.panel && editor.theme.panel.find('statusbar')[0];
      if (statusbar) {
        statusbar.insert(
          {
            type: 'label',
            name: 'margin-status',
            text: 'Left Margin: 0%, Right Margin: 0%',
            classes: 'margin-status-bar'
          },
          0
        );
      }
    });
  },
  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
});
